export enum TaskStatus {
    ALL = -1,
    REQUESTED = 0,
    OPENED = 1,
    CLOSED = 2,
}

export type HistoryType = 'task' | 'project' | 'project_work_object'